// lib/metaConfig.ts
// import { ASSET_PREFIX } from "../../config";

export interface MetaTags {
  title: string;
  description: string;
  keywords?: string;
  author?: string;
  canonical?: string;
  robots?: string;
  googlebot?: string;
  image?: string;
  openGraph?: {
    title?: string;
    description?: string;
    url?: string;
    type?: string;
    siteName?: string;
    images?: string;
  };
}

export const metaConfig: Record<string, MetaTags> = {
  "/": {
    title: "Plus Willa 25 - 3 and 4 BHK Villa for Sale in Coimbatore",
    description:
      "Plus Willa 25 Offers Luxury 3 and 4 BHK Villas for Sale in Coimbatore. Plus Willa, a Just Move in Villa and Start Living from Day One, Book Your Site Visit Today!",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/",
    author: "Pluswilla",
    image: "https://pluswilla.com/images/video-thumbnail.webp"
  },
  "/about": {
    title: "About Us - PlusWilla",
    description:
      "+Willa 25 Luxury Villa in TVS Nagar, Coimbatore. Pluswilla Offers Future Ready, Finished, Finished Villas to make your Living Effortless from Day 1.",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/about",
    image: "https://www.pluswilla.com/images/about-subban.webp",
    author: "Pluswilla"
  },
  "/privacy-policy": {
    title: "+Willa - Privacy Policy",
    description: "Learn more about + Willa’s privacy policy and practices, data protection measures, user rights, and compliance with applicable privacy regulations",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/privacy-policy",
    author: "Pluswilla",
    image: "https://www.pluswilla.com/images/about-subban.webp",
  },
  "/media": {
    title: "Our Media Coverage - PlusWilla",
    description:
      "Stay Updated with the Media Coverage News from PlusWilla (+Willa). Get the Latest Updates from Our Media Section Today!",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/media",
    author: "Pluswilla",
    image: "https://www.pluswilla.com/images/about-subban.webp",
  },
  "/contact-us": {
    title: "Contact Us - PlusWilla",
    description:
      "Fill Out the Enquiry Form or Contact Us Via Email or Telephone. We're Here to Help and Answer Any Questions You Might Have. Enquire Now.",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/contact-us",
    image: "https://www.pluswilla.com/images/shuttle-bg.webp",
    author: "Pluswilla"
  },
  "/blog": {
    title: "Read Our Latest Blogs - Plus Willa",
    description:
      "Stay Informed with the Latest Property Trends, Market Updates, and Community Growth in Coimbatore from a Professional at Pluswilla. Explore Our Blogs and Stay Updated.",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/blog",
    image: "https://www.pluswilla.com/images/about-subban.webp",
    author: "Pluswilla"
  },
  "/gallery": {
    title: "Our Gallery - PlusWilla",
    description:
      "Explore the Project Gallery of +Willa to Discover the Visuals of Our Modernized Amenities that Blend with Technology to Make Up the Living Futuristic Looks",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/gallery",
    image: "https://www.pluswilla.com/images/about-subban.webp",
    author: "Pluswilla"
  },
  "/highlights": {
    title: "Highlights - +Willa",
    description: "Discover our +Willa highlights includes solar power, sky garden, home automation, centralized vacuum, space-optimizing furniture and modular kitchens.",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/highlights",
    image: "https://www.pluswilla.com/images/shuttle-bg.webp",
    author: "Pluswilla"
  },
  "/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore": {
    title:
      "5 Reasons TVS Nagar is Emerging as a Growth Hub in Coimbatore - PlusWilla",
    description:
      "Know Why Real Estate Experts State TVS Nagar as the emerging Hub in Coimbatore? Here are the reasons Why TVS Nagar may soon become one of the top areas in Coimbatore.",
    image:
      "https://pluswilla.com/images/blogs/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore.webp",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore",
    author: "Pluswilla"
  },
  "/top-reasons-to-invest-in-villas-plots-in-tvs-nagar": {
    title: "Top Reasons to Invest in Villas and Plots in TVS Nagar",
    description:
      "Here are the Top Reasons Why Investing in TVS Nagar Coimbatore is the Perfect Investment. Look at why Pluswilla is a standout choice for it",
    image:
      "https://pluswilla.com/images/blogs/top-reasons-to-invest-in-villas-plots-in-tvs-nagar.webp",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/top-reasons-to-invest-in-villas-plots-in-tvs-nagar",
    author: "Pluswilla"
  },
  "/market-shopping-places-near-tvs-nagar": {
    title: "Markets and Shopping Places around TVS Nagar, Coimbatore - PlusWilla",
    description:
      "Know all the spotlighted Markets and Shopping places in and around TVS Nagar, the destination that makes living better and comfortable",
    image:
      "https://pluswilla.com/images/blogs/market-shopping-places-near-tvs-nagar.webp",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/market-shopping-places-near-tvs-nagar",
    author: "Pluswilla"
  },
  "/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore": {
    title:
      "TVS Nagar is Next to Bloom as a New Residential Hub for Coimbatore - +Willa",
    description:
      "Explore TVS Nagar, a Locality with Modern Amenities, Enhanced Connectivity, and Solid Growth in Coimbatore, making it a Smart Choice for Your Next Home.",
    image:
      "https://pluswilla.com/images/blogs/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore.webp",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore",
    author: "Pluswilla"
  },
  "/why-pluswilla-has-built-in-solar-power": {
    title:
      "Why +Willa Has Built-In Solar Power",
    description: "Why +Willa Has Built-In Solar Power: This blog explains about the saving your EB Bill for 25 Years and Earn ₹24.6 Lakhs in Return",
    image: "https://pluswilla.com/images/blogs/why-pluswilla-banner.webp",
    canonical: "https://www.pluswilla.com/why-pluswilla-has-built-in-solar-power",
    author: "Pluswilla"
  },
  "/the-science-behind-plus-willas-sky-garden": {
    title: "The Science Behind +Willa’s Sky Garden",
    description: "The Science Behind +Willa’s Sky Garden: This Blogs explain about How pluswilla Make Your Terrace Garden Safe, Durable and Ready from Day 1",
    image: "https://pluswilla.com/images/blogs/why-pluswilla-banner.webp",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/the-science-behind-plus-willas-sky-garden",
    author: "Pluswilla"
  },
  "/beautiful-ways-to-use-your-pluswilla-sky-garden": {
    title: "21 Beautiful Ways to Use Your +Willa Sky Garden",
    description: "Explore 21 inspiring ways to enjoy your +Willa Sky Garden, Because it’s not just a terrace - it’s an engineered living space",
    image: "https://pluswilla.com/images/blogs/why-pluswilla-banner.webp",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/beautiful-ways-to-use-your-pluswilla-sky-garden",
    author: "Pluswilla"
  },
  "/the-real-timeline-of-setting-up-a-villa": {
    title: "The Real Timeline of Setting Up a Villa - PlusWilla 25 ",
    description: "The Real Timeline of Setting Up a Villa, and Why Not Instant? Take a look at the Phase-Wise Breakdown of what really happens after you receive the keys.",
    image: "https://pluswilla.com/images/blogs/why-pluswilla-banner.webp",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/the-real-timeline-of-setting-up-a-villa",
    author: "Pluswilla"
  },
  "/why-we-believe-homes-should-work-harder-for-you-not-the-other-way-around-how-pluswilla-makes-it-happen": {
    title: "Learn How +Willa Made Your Homes Work Harder for You",
    description: "Discover How Pluswilla Designs Future-Ready Villas, Where Sustainability, Flexible Spacing, and Smart Automation Work Together to Simplify Living and Enhance Comfort.",
    image: "https://pluswilla.com/images/blogs/why-we-believe-homes-should-work-harder-for-you-not-the-other-way-around-how-pluswilla-makes-it-happen.webp",
    robots: "index, follow",
    canonical: "https://www.pluswilla.com/why-we-believe-homes-should-work-harder-for-you-not-the-other-way-around-how-pluswilla-makes-it-happen",
    author: "Pluswilla"
  },
};

export const schemaConfig: Record<string, object> = {
  "/": {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://www.pluswilla.com/#webpage",
        url: "https://www.pluswilla.com/",
        name: "Plus Willa - 3 and 4 BHK Villa for Sale in Coimbatore",
        description:"PlusWilla Offers Luxury 3 and 4 BHK Villas for Sale in Coimbatore. +Willa, a Just Move in Villa and Start Living from Day One, Book Your Site Visit Today!",

        isPartOf: {
          "@id": "https://www.pluswilla.com/#website",
        },
        about: {
          "@id": "https://www.pluswilla.com/#organization",
        },
        primaryImageOfPage: {
          "@type": "ImageObject",
          url: "https://www.pluswilla.com/images/plus-willa-logo_final.svg",
        },
      },
    ]
  },
   "/about": {
    "@context": "https://schema.org",
    "@graph": [
      
      {
        "@type": "AboutPage",
        "@id": "https://www.pluswilla.com/about/#aboutpage",
        url: "https://www.pluswilla.com/about",
        name: "About Us - PlusWilla",
        description: "+Willa 25 Luxury Villa in TVS Nagar, Coimbatore. Pluswilla Offers Future Ready, Finished, Finished Villas to make your Living Effortless from Day 1.",
        isPartOf: {
          "@id": "https://www.pluswilla.com/#website",
        },
        about: {
          "@id": "https://www.pluswilla.com/#organization",
        },
        primaryImageOfPage: {
          "@type": "ImageObject",
          url: "https://www.pluswilla.com/images/plus-willa-logo_final.svg",
        },
      },
    ]
  },
  "/contact-us": {
    "@context": "https://schema.org",
    "@graph": [
       {
        "@type": "ContactPage",
        "@id": "https://www.pluswilla.com/contact-us/#contactpage",
        url: "https://www.pluswilla.com/contact-us",
        name: "Contact Us - PlusWilla",
        description: "Fill Out the Enquiry Form or Contact Us Via Email or Telephone. We're Here to Help and Answer Any Questions You Might Have. Enquire Now.",
        isPartOf: {
          "@id": "https://www.pluswilla.com/#website",
        },
        about: {
          "@id": "https://www.pluswilla.com/#organization",
        },
      },

      {
        "@type": "ContactPoint",
        "@id": "https://www.pluswilla.com/contact-us/#contactpoint",
         telephone: "+91 73737 37166",
        contactType: "customer support",
        areaServed: "IN",
      },
    ]
  },
  "/blog": {
    "@context": "https://schema.org",
    "@graph": [
      
       {
        "@type": "BreadcrumbList",
        "@id": "https://www.pluswilla.com/blog/#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.pluswilla.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: "https://www.pluswilla.com/blog",
          },
        ],
      },
    ]
  },
  "/why-we-believe-homes-should-work-harder-for-you-not-the-other-way-around-how-pluswilla-makes-it-happen": {
    "@context": "https://schema.org",
    "@graph": [
       {
      "@type": "BlogPosting",
      "@id": "https://www.pluswilla.com/why-we-believe-homes-should-work-harder-for-you-not-the-other-way-around-how-pluswilla-makes-it-happen/#blogposting",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.pluswilla.com/why-we-believe-homes-should-work-harder-for-you-not-the-other-way-around-how-pluswilla-makes-it-happen"
        },
      "headline": "Learn How +Willa Made Your Homes Work Harder for You",
      "description": "Discover How Pluswilla Designs Future-Ready Villas, Where Sustainability, Flexible Spacing, and Smart Automation Work Together to Simplify Living and Enhance Comfort.",
      "image": "https://www.pluswilla.com/images/blogs/why-we-believe-homes-should-work-harder-for-you-not-the-other-way-around-how-pluswilla-makes-it-happen.webp",
      "url": "https://www.pluswilla.com/why-we-believe-homes-should-work-harder-for-you-not-the-other-way-around-how-pluswilla-makes-it-happen",
      "datePublished": "2024-01-10T09:00:00+05:30",
      "dateModified": "2024-01-10T09:00:00+05:30",
      "author": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.pluswilla.com/images/plus-willa-logo_final.svg"
        }
      },
      "keywords": [
        "villa",     
        "villa for Sale",
       
      ],
      "genre": ["Investor","Property Developer", "Buyer"],
      "about": [
        {
          "@type": "Thing",
          "name": "Learn How +Willa Made Your Homes Work Harder for You"
        }
      ],
      "audience": {
        "@type": "Audience",
        "audienceType": ["General Public"]
      }
    },
       {
        "@type": "BreadcrumbList",
        "@id": "https://www.pluswilla.com/why-we-believe-homes-should-work-harder-for-you-not-the-other-way-around-how-pluswilla-makes-it-happen/#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.pluswilla.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: "https://www.pluswilla.com/blog",
          },
           {
            "@type": "ListItem",
            position: 3,
            name: "Why We Believe Homes Should Work Harder for You - Not the Other Way Around: How +Willa makes it happen",
            item: "https://www.pluswilla.com/why-we-believe-homes-should-work-harder-for-you-not-the-other-way-around-how-pluswilla-makes-it-happen",
          },

        ],
      },
    ]
  },
   "/the-real-timeline-of-setting-up-a-villa": {
    "@context": "https://schema.org",
    "@graph": [
       {
      "@type": "BlogPosting",
      "@id": "https://www.pluswilla.com/the-real-timeline-of-setting-up-a-villa/#blogposting",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.pluswilla.com/the-real-timeline-of-setting-up-a-villa"
        },
      "headline": "The Real Timeline of Setting Up a Villa - PlusWilla 25",
      "description": "The Real Timeline of Setting Up a Villa, and Why Not Instant? Take a look at the Phase-Wise Breakdown of what really happens after you receive the keys.",
      "image": "https://www.pluswilla.com/images/blogs/the-real-timeline-of-setting-up-a-villa.webp",
      "url": "https://www.pluswilla.com/the-real-timeline-of-setting-up-a-villa",
      "datePublished": "2025-12-18T09:00:00+05:30",
      "dateModified": "2025-12-18T09:00:00+05:30",
      "author": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.pluswilla.com/images/plus-willa-logo_final.svg"
        }
      },
      "keywords": [
        "villa",     
        "villa for Sale",
       
      ],
      "genre": ["Investor","Property Developer", "Buyer"],
      "about": [
        {
          "@type": "Thing",
          "name": "The Real Timeline of Setting Up a Villa - PlusWilla 25"
        }
      ],
      "audience": {
        "@type": "Audience",
        "audienceType": ["General Public"]
      }
    },
       {
        "@type": "BreadcrumbList",
        "@id": "https://www.pluswilla.com/the-real-timeline-of-setting-up-a-villa/#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.pluswilla.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: "https://www.pluswilla.com/blog",
          },
           {
            "@type": "ListItem",
            position: 3,
            name: "The Real Timeline of Setting Up a Villa",
            item: "https://www.pluswilla.com/the-real-timeline-of-setting-up-a-villa",
          },

        ],
      },
    ]
  },
   "/beautiful-ways-to-use-your-pluswilla-sky-garden": {
    "@context": "https://schema.org",
    "@graph": [
       {
      "@type": "BlogPosting",
      "@id": "https://www.pluswilla.com/beautiful-ways-to-use-your-pluswilla-sky-garden/#blogposting",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.pluswilla.com/beautiful-ways-to-use-your-pluswilla-sky-garden"
        },
      "headline": "21 Beautiful Ways to Use Your +Willa Sky Garden",
      "description": "Explore 21 inspiring ways to enjoy your +Willa Sky Garden, Because it’s not just a terrace - it’s an engineered living space",
      "image": "https://www.pluswilla.com/images/blogs/beautiful-ways-to-use-your-pluswilla-sky-garden.webp",
      "url": "https://www.pluswilla.com/beautiful-ways-to-use-your-pluswilla-sky-garden",
      "datePublished": "2025-12-11T09:00:00+05:30",
      "dateModified": "2025-12-11T09:00:00+05:30",
      "author": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.pluswilla.com/images/plus-willa-logo_final.svg"
        }
      },
      "keywords": [
        "villa",     
        "villa for Sale",
       
      ],
      "genre": ["Investor","Property Developer", "Buyer"],
      "about": [
        {
          "@type": "Thing",
          "name": "21 Beautiful Ways to Use Your +Willa Sky Garden"
        }
      ],
      "audience": {
        "@type": "Audience",
        "audienceType": ["General Public"]
      }
    },
       {
        "@type": "BreadcrumbList",
        "@id": "https://www.pluswilla.com/beautiful-ways-to-use-your-pluswilla-sky-garden/#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.pluswilla.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: "https://www.pluswilla.com/blog",
          },
           {
            "@type": "ListItem",
            position: 3,
            name: "21 Beautiful Ways to Use Your +Willa Sky Garden",
            item: "https://www.pluswilla.com/beautiful-ways-to-use-your-pluswilla-sky-garden",
          },

        ],
      },
    ]
  },
  "/the-science-behind-plus-willas-sky-garden": {
    "@context": "https://schema.org",
    "@graph": [
       {
      "@type": "BlogPosting",
      "@id": "https://www.pluswilla.com/the-science-behind-plus-willas-sky-garden/#blogposting",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.pluswilla.com/the-science-behind-plus-willas-sky-garden"
        },
      "headline": "The Science Behind +Willa’s Sky Garden",
      "description": "The Science Behind +Willa’s Sky Garden: This Blogs explain about How pluswilla Make Your Terrace Garden Safe, Durable and Ready from Day 1",
      "image": "https://www.pluswilla.com/images/blogs/terrace-garden-safe.webp",
      "url": "https://www.pluswilla.com/the-science-behind-plus-willas-sky-garden",
      "datePublished": "2025-12-11T09:00:00+05:30",
      "dateModified": "2025-12-11T09:00:00+05:30",
      "author": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.pluswilla.com/images/plus-willa-logo_final.svg"
        }
      },
      "keywords": [
        "villa",     
        "villa for Sale",
       
      ],
      "genre": ["Investor","Property Developer", "Buyer"],
      "about": [
        {
          "@type": "Thing",
          "name": "The Science Behind +Willa’s Sky Garden"
        }
      ],
      "audience": {
        "@type": "Audience",
        "audienceType": ["General Public"]
      }
    },
       {
        "@type": "BreadcrumbList",
        "@id": "https://www.pluswilla.com/the-science-behind-plus-willas-sky-garden/#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.pluswilla.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: "https://www.pluswilla.com/blog",
          },
           {
            "@type": "ListItem",
            position: 3,
            name: "The Science Behind +Willa’s Sky Garden",
            item: "https://www.pluswilla.com/the-science-behind-plus-willas-sky-garden",
          },

        ],
      },
    ]
  },

   "/why-pluswilla-has-built-in-solar-power": {
    "@context": "https://schema.org",
    "@graph": [
       {
      "@type": "BlogPosting",
      "@id": "https://www.pluswilla.com/why-pluswilla-has-built-in-solar-power/#blogposting",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.pluswilla.com/why-pluswilla-has-built-in-solar-power"
        },
      "headline": "Why +Willa Has Built-In Solar Power",
      "description": "Why +Willa Has Built-In Solar Power: This blog explains about the saving your EB Bill for 25 Years and Earn ₹24.6 Lakhs in Return",
      "image": "https://www.pluswilla.com/images/blogs/why-pluswilla-banner.webp",
      "url": "https://www.pluswilla.com/why-pluswilla-has-built-in-solar-power",
      "datePublished": "2025-11-22T09:00:00+05:30",
      "dateModified": "2025-11-22T09:00:00+05:30",
      "author": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.pluswilla.com/images/plus-willa-logo_final.svg"
        }
      },
      "keywords": [
        "villa",     
        "villa for Sale",
       
      ],
      "genre": ["Investor","Property Developer", "Buyer"],
      "about": [
        {
          "@type": "Thing",
          "name": "Why +Willa Has Built-In Solar Power"
        }
      ],
      "audience": {
        "@type": "Audience",
        "audienceType": ["General Public"]
      }
    },
       {
        "@type": "BreadcrumbList",
        "@id": "https://www.pluswilla.com/why-pluswilla-has-built-in-solar-power/#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.pluswilla.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: "https://www.pluswilla.com/blog",
          },
           {
            "@type": "ListItem",
            position: 3,
            name: "Why +Willa Has Built-In Solar Power",
            item: "https://www.pluswilla.com/why-pluswilla-has-built-in-solar-power",
          },

        ],
      },
    ]
  },
  "/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore": {
    "@context": "https://schema.org",
    "@graph": [
       {
      "@type": "BlogPosting",
      "@id": "https://www.pluswilla.com/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore/#blogposting",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.pluswilla.com/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore"
        },
      "headline": "TVS Nagar is Next to Bloom as a New Residential Hub for Coimbatore - +Willa",
      "description": "Explore TVS Nagar, a Locality with Modern Amenities, Enhanced Connectivity, and Solid Growth in Coimbatore, making it a Smart Choice for Your Next Home.",
      "image": "https://www.pluswilla.com/images/blogs/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore.webp",
      "url": "https://www.pluswilla.com/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore",
      "datePublished": "2025-11-01T09:00:00+05:30",
      "dateModified": "2025-11-01T09:00:00+05:30",
      "author": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.pluswilla.com/images/plus-willa-logo_final.svg"
        }
      },
      "keywords": [
        "villa",     
        "villa for Sale",
       
      ],
      "genre": ["Investor","Property Developer", "Buyer"],
      "about": [
        {
          "@type": "Thing",
          "name": "TVS Nagar is Next to Bloom as a New Residential Hub for Coimbatore - +Willa"
        }
      ],
      "audience": {
        "@type": "Audience",
        "audienceType": ["General Public"]
      }
    },
       {
        "@type": "BreadcrumbList",
        "@id": "https://www.pluswilla.com/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore/#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.pluswilla.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: "https://www.pluswilla.com/blog",
          },
           {
            "@type": "ListItem",
            position: 3,
            name: "TVS Nagar is next to bloom as a new residential hub for Coimbatore - +Willa",
            item: "https://www.pluswilla.com/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore",
          },

        ],
      },
    ]
  },
   "/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore": {
    "@context": "https://schema.org",
    "@graph": [
       {
      "@type": "BlogPosting",
      "@id": "https://www.pluswilla.com/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore/#blogposting",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.pluswilla.com/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore"
        },
      "headline": "5 Reasons TVS Nagar is Emerging as a Growth Hub in Coimbatore - PlusWilla",
      "description": "Know Why Real Estate Experts State TVS Nagar as the emerging Hub in Coimbatore? Here are the reasons Why TVS Nagar may soon become one of the top areas in Coimbatore.",
      "image": "https://www.pluswilla.com/images/blogs/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore.webp",
      "url": "https://www.pluswilla.com/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore",
      "datePublished": "2025-11-03T09:00:00+05:30",
      "dateModified": "2025-11-03T09:00:00+05:30",
      "author": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.pluswilla.com/images/plus-willa-logo_final.svg"
        }
      },
      "keywords": [
        "villa",     
        "villa for Sale",
       
      ],
      "genre": ["Investor","Property Developer", "Buyer"],
      "about": [
        {
          "@type": "Thing",
          "name": "5 Reasons TVS Nagar is Emerging as a Growth Hub in Coimbatore - PlusWilla"
        }
      ],
      "audience": {
        "@type": "Audience",
        "audienceType": ["General Public"]
      }
    },
       {
        "@type": "BreadcrumbList",
        "@id": "https://www.pluswilla.com/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore/#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.pluswilla.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: "https://www.pluswilla.com/blog",
          },
           {
            "@type": "ListItem",
            position: 3,
            name: "5 Reasons TVS Nagar is Emerging as a Growth Hub in Coimbatore",
            item: "https://www.pluswilla.com/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore",
          },

        ],
      },
    ]
  },
   "/top-reasons-to-invest-in-villas-plots-in-tvs-nagar": {
    "@context": "https://schema.org",
    "@graph": [
       {
      "@type": "BlogPosting",
      "@id": "https://www.pluswilla.com/top-reasons-to-invest-in-villas-plots-in-tvs-nagar/#blogposting",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.pluswilla.com/top-reasons-to-invest-in-villas-plots-in-tvs-nagar"
        },
      "headline": "Top Reasons to Invest in Villas and Plots in TVS Nagar",
      "description": "Here are the Top Reasons Why Investing in TVS Nagar Coimbatore is the Perfect Investment. Look at why Pluswilla is a standout choice for it",
      "image": "https://www.pluswilla.com/images/blogs/top-reasons-to-invest-in-villas-plots-in-tvs-nagar.webp",
      "url": "https://www.pluswilla.com/top-reasons-to-invest-in-villas-plots-in-tvs-nagar",
      "datePublished": "2025-11-02T09:00:00+05:30",
      "dateModified": "2025-11-02T09:00:00+05:30",
      "author": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.pluswilla.com/images/plus-willa-logo_final.svg"
        }
      },
      "keywords": [
        "villa",     
        "villa for Sale",
       
      ],
      "genre": ["Investor","Property Developer", "Buyer"],
      "about": [
        {
          "@type": "Thing",
          "name": "Top Reasons to Invest in Villas and Plots in TVS Nagar"
        }
      ],
      "audience": {
        "@type": "Audience",
        "audienceType": ["General Public"]
      }
    },
       {
        "@type": "BreadcrumbList",
        "@id": "https://www.pluswilla.com/top-reasons-to-invest-in-villas-plots-in-tvs-nagar/#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.pluswilla.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: "https://www.pluswilla.com/blog",
          },
           {
            "@type": "ListItem",
            position: 3,
            name: "Top Reasons to Invest in Villas & Plots in TVS Nagar",
            item: "https://www.pluswilla.com/top-reasons-to-invest-in-villas-plots-in-tvs-nagar",
          },

        ],
      },
    ]
  },
   "/market-shopping-places-near-tvs-nagar": {
    "@context": "https://schema.org",
    "@graph": [
       {
      "@type": "BlogPosting",
      "@id": "https://www.pluswilla.com/market-shopping-places-near-tvs-nagar/#blogposting",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://www.pluswilla.com/market-shopping-places-near-tvs-nagar"
        },
      "headline": "Markets and Shopping Places around TVS Nagar, Coimbatore - PlusWilla",
      "description": "Know all the spotlighted Markets and Shopping places in and around TVS Nagar, the destination that makes living better and comfortable",
      "image": "https://www.pluswilla.com/images/blogs/market-shopping-places-near-tvs-nagar.webp",
      "url": "https://www.pluswilla.com/market-shopping-places-near-tvs-nagar",
      "datePublished": "2025-11-01T09:00:00+05:30",
      "dateModified": "2025-11-01T09:00:00+05:30",
      "author": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Plus Willa",
        "url": "https://www.pluswilla.com/",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.pluswilla.com/images/plus-willa-logo_final.svg"
        }
      },
      "keywords": [
        "villa",     
        "villa for Sale",
       
      ],
      "genre": ["Investor","Property Developer", "Buyer"],
      "about": [
        {
          "@type": "Thing",
          "name": "Markets and Shopping Places around TVS Nagar, Coimbatore - PlusWilla"
        }
      ],
      "audience": {
        "@type": "Audience",
        "audienceType": ["General Public"]
      }
    },
       {
        "@type": "BreadcrumbList",
        "@id": "https://www.pluswilla.com/market-shopping-places-near-tvs-nagar/#breadcrumb",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://www.pluswilla.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Blog",
            item: "https://www.pluswilla.com/blog",
          },
           {
            "@type": "ListItem",
            position: 3,
            name: "Markets & Shopping Places near TVS Nagar",
            item: "https://www.pluswilla.com/market-shopping-places-near-tvs-nagar",
          },

        ],
      },
    ]
  },
  
}
